/* eslint-disable */
import React, { useEffect } from 'react';
import cx from 'classnames';
import { func, object } from 'prop-types';
import { connect } from 'react-redux';

import { HeadWrapper } from '../../elements';
import { setFlag } from '../../redux/flags/flags';
import Title from '../../elements/Title/Title';
import TriggerOnEnter from '../../elements/TriggerOnEnter/TriggerOnEnter';
import TermsPrivacy from '../../components/TermsPrivacyLegal/TermsPrivacy';
// import menu from './menu';
import strings from '../../lang/lang';

const mapDispatchToProps = {
  setFlag,
};

function Terms(props) {
  useEffect(() => {
    props.setFlag('isHeaderTermsLegals', true);
    return () => {
      props.setFlag('isHeaderTermsLegals', false);
    };
  }, []);
  // return <TermsPrivacy menu={menu} title="Terms and Conditions" Content={Content} />;
  return <TermsPrivacy title="Terms and Conditions" Content={Content} />;
}
export default connect(null, mapDispatchToProps)(Terms);

const Content = ({ wayPointCallback, className, offset }) => {
  return (
    <div className={cx({ [className]: !!className })}>
      <HeadWrapper
        href="https://developer.staq.io/terms"
        title="Terms & Conditions | Staq  Developer Portal"
        description="Understand the terms governing Staq's APIs. These conditions outline your rights and responsibilities for accessing and using our APIs effectively and legally."
      />
      <div className="content-box">
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('overview')}>
          <>
            {/* <Title className="content__title content__title--2" sizeText="size-3" tagName="h2">
              Summary
            </Title> */}
            <Title id="overview" className="content__title content__title--3" tagName="h3">
              {strings.termOfUsePage.text.p1Title}
            </Title>
            <p>
              {strings.formatString(
                strings.termOfUsePage.text.p1,
                <a href="https://developer.staq.io" target="_blank">
                  {strings.termOfUsePage.text.p1_0}
                </a>,
                <strong>{strings.termOfUsePage.text.p1_1}</strong>,
                <i>{strings.termOfUsePage.text.p1_2}</i>,
                <i>{strings.termOfUsePage.text.p1_3}</i>
              )}
            </p>
            <ul className="content__list">
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.p11,
                  <a href="https://staq.io/privacy-policy" target="_blank">
                    {strings.termOfUsePage.text.p11_0}
                  </a>
                )}
              </li>
              <li>{strings.termOfUsePage.text.p12}</li>
              <li>{strings.termOfUsePage.text.p13}</li>
              <li>{strings.termOfUsePage.text.p14}</li>
              <li>{strings.termOfUsePage.text.p15}</li>
            </ul>
          </>
        </TriggerOnEnter>
      </div>
      <div className="content-box">
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('custom_terms')}>
          <>
            {/* <Title className="content__title content__title--2" tagName="h2">
              Terms and conditions
            </Title> */}
            <Title
              className="content__title content__title--3"
              tagName="h3"
              id="customer-terms-of-service"
            >
              {strings.termOfUsePage.text.p2Title}
            </Title>
            <ul className="content__list">
              <li>{strings.termOfUsePage.text.p21}</li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.p21_a,
                  <strong>{strings.termOfUsePage.text.p21_a_0}</strong>
                )}
              </li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.p21_b,
                  <strong>{strings.termOfUsePage.text.p21_b_0}</strong>
                )}
                <ul className="content__list content__list--child">
                  <li>{strings.termOfUsePage.text.p21_b_i}</li>
                  <li>{strings.termOfUsePage.text.p21_b_ii}</li>
                  <li>{strings.termOfUsePage.text.p21_b_iii}</li>
                </ul>
              </li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.p21_c,
                  <strong>{strings.termOfUsePage.text.p21_c_0}</strong>
                )}
              </li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.p21_d,
                  <strong>{strings.termOfUsePage.text.p21_d_0}</strong>
                )}
              </li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.p21_e,
                  <strong>{strings.termOfUsePage.text.p21_e_0}</strong>
                )}
                <ul className="content__list content__list--child">
                  <li>
                    <p>{strings.termOfUsePage.text.p21_e_p1}</p>
                  </li>
                  <li>
                    <p>{strings.termOfUsePage.text.p21_e_p2}</p>
                  </li>
                  <li>
                    <p>{strings.termOfUsePage.text.p21_e_p3}</p>
                  </li>
                  <li>
                    <p>{strings.termOfUsePage.text.p21_e_p4}</p>
                  </li>
                  <li>
                    <p>{strings.termOfUsePage.text.p21_e_p5}</p>
                  </li>
                  <li>
                    <p>{strings.termOfUsePage.text.p21_e_p6}</p>
                  </li>
                  <li>
                    <p>{strings.termOfUsePage.text.p21_e_p7}</p>
                  </li>
                  <li>
                    <p>{strings.termOfUsePage.text.p21_e_p8}</p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  {strings.formatString(
                    strings.termOfUsePage.text.p21_f,
                    <strong>{strings.termOfUsePage.text.p21_f_0}</strong>
                  )}
                </p>
              </li>
              <li>
                <p>
                  {strings.formatString(
                    strings.termOfUsePage.text.p21_g,
                    <strong>{strings.termOfUsePage.text.p21_g_0}</strong>
                  )}
                </p>
              </li>
              <li>
                <p>
                  {strings.formatString(
                    strings.termOfUsePage.text.p21_h,
                    <strong>{strings.termOfUsePage.text.p21_h_0}</strong>
                  )}
                </p>
              </li>
              <li>
                <p>
                  {strings.formatString(
                    strings.termOfUsePage.text.p21_i,
                    <strong>{strings.termOfUsePage.text.p21_i_0}</strong>
                  )}
                </p>
              </li>
              <li>
                <p>
                  {strings.formatString(
                    strings.termOfUsePage.text.p21_j,
                    <strong>{strings.termOfUsePage.text.p21_j_0}</strong>
                  )}
                </p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p21_k}</p>
              </li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('user_terms')}>
          <>
            <Title
              className="content__title content__title--3"
              tagName="h3"
              id="user-terms-of-service"
            >
              {strings.termOfUsePage.text.p3Title}
            </Title>
            <ul className="content__list">
              <li>{strings.termOfUsePage.text.p31}</li>
              <li>{strings.termOfUsePage.text.p32}</li>
              <li>
                <p>{strings.termOfUsePage.text.p321}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p322}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p323}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p324}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p325}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p326}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p327}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p328}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p329}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p3210}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p33}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p34}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p35}</p>
              </li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('customer_specific')}>
          <>
            <Title
              className="content__title content__title--3"
              tagName="h3"
              id="customer-specific-supplies"
            >
              <strong>{strings.termOfUsePage.text.p4Title}</strong>
            </Title>
            <ul className="content__list">
              <li>{strings.termOfUsePage.text.p41}</li>
              <li>
                <p>
                  {strings.formatString(
                    strings.termOfUsePage.text.p411,
                    <strong>{strings.termOfUsePage.text.p411_0}</strong>
                  )}
                </p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p412}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p413}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p414}</p>
              </li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('api_terms')}>
          <>
            <Title
              className="content__title content__title--3 content__title"
              tagName="h3"
              id="api-terms-of-service"
            >
              <strong>Interfacing</strong>
            </Title>
            <ul className="content__list">
              <li>
                <p>{strings.termOfUsePage.text.p5}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p51}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p52}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p53}</p>
              </li>
            </ul>
          </>
        </TriggerOnEnter>
      </div>
      <div className="content-box">
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('privacy')}>
          <>
            {/* <Title className="content__title content__title--2" tagName="h2">
              Policies
            </Title> */}
            <Title
              className="content__title content__title--3"
              tagName="h3"
              id="privacy-shield-notice"
            >
              {strings.termOfUsePage.text.p6Title}
            </Title>
            <ul className="content__list">
              <li>{strings.termOfUsePage.text.p61}</li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('acceptable_policy')}>
          <>
            <Title
              className="content__title content__title--3"
              tagName="h3"
              id="acceptable-use-policy"
            >
              {strings.termOfUsePage.text.p7Title}
            </Title>
            <ul className="content__list">
              <li>{strings.termOfUsePage.text.p71}</li>
              <li>
                <p>{strings.termOfUsePage.text.p711}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p712}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p713}</p>
              </li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('finto_sub')}>
          <>
            <Title
              className="content__title content__title--3"
              tagName="h3"
              id="finto-sub-processors"
            >
              {strings.termOfUsePage.text.p8Title}
            </Title>
            <ul className="content__list">
              <li>{strings.termOfUsePage.text.p81}</li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('confidentiality')}>
          <>
            <Title className="content__title content__title--3" tagName="h3" id="confidentiality">
              {strings.termOfUsePage.text.p9Title}
            </Title>
            <ul className="content__list">
              <li>{strings.termOfUsePage.text.p91}</li>
              <li>{strings.termOfUsePage.text.p92}</li>
              <li>
                <p>{strings.termOfUsePage.text.p921}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p922}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p923}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p93}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p94}</p>
              </li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('intellectual')}>
          <>
            <Title className="content__title content__title--3" tagName="h3" id="intellectual">
              {strings.termOfUsePage.text.p10Title}
            </Title>
            <ul className="content__list">
              <li>
                <p>{strings.termOfUsePage.text.p_11}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p_12}</p>
              </li>
              <li>
                <p>
                  {strings.formatString(
                    strings.termOfUsePage.text.p_13,
                    <strong>{strings.termOfUsePage.text.p_13_0}</strong>
                  )}
                </p>
              </li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('security')}>
          <>
            <Title className="content__title content__title--3" tagName="h3" id="security">
              {strings.termOfUsePage.text.p14Title}
            </Title>
            <ul className="content__list">
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.p141,
                  <strong>{strings.termOfUsePage.text.p141_0}</strong>
                )}
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p141_i}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p141_ii}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p141_iii}</p>
              </li>
              <li>
                <p>
                  {strings.formatString(
                    strings.termOfUsePage.text.p141_iv,
                    <a href="https://owasp.org/www-project-top-ten/">
                      {strings.termOfUsePage.text.p141_iv_0}
                    </a>
                  )}
                </p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p141_v}</p>
              </li>
              <li>
                <p>{strings.termOfUsePage.text.p142}</p>
              </li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('suspension')}>
          <>
            <Title className="content__title content__title--3" tagName="h3" id="suspension">
              {strings.termOfUsePage.text.pLastTitle}
            </Title>
            <p>
              <i>{strings.termOfUsePage.text.pWithCause}</i>
            </p>
            <ul className="content__list">
              <li>
                {strings.termOfUsePage.text.pWithCause_l}
                <ul className="content__list content__list--child">
                  <li>{strings.termOfUsePage.text.pWithCause_l_i}</li>
                  <li>{strings.termOfUsePage.text.pWithCause_l_ii}</li>
                  <li>{strings.termOfUsePage.text.pWithCause_l_iii}</li>
                </ul>
              </li>
            </ul>
            <p>
              <i>{strings.termOfUsePage.text.pWithoutCause}</i>
            </p>
            <ul className="content__list">
              <li>{strings.termOfUsePage.text.pWithoutCause_m}</li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('general')}>
          <>
            <Title
              className="content__title content__title--3 content__title"
              tagName="h3"
              id="general"
            >
              {strings.termOfUsePage.text.pWithoutCause_general}
            </Title>
            <ul className="content__list">
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.pWithoutCause_n,
                  <strong>{strings.termOfUsePage.text.pWithoutCause_n_0}</strong>
                )}
              </li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.pWithoutCause_o,
                  <strong>{strings.termOfUsePage.text.pWithoutCause_o_0}</strong>
                )}
              </li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.pWithoutCause_p,
                  <strong>{strings.termOfUsePage.text.pWithoutCause_p_0}</strong>
                )}
              </li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.pWithoutCause_q,
                  <strong>{strings.termOfUsePage.text.pWithoutCause_q_0}</strong>
                )}
              </li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.pWithoutCause_forceMaj,
                  <strong>{strings.termOfUsePage.text.pWithoutCause_forceMaj_0}</strong>
                )}
              </li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.pWithoutCause_r,
                  <strong>{strings.termOfUsePage.text.pWithoutCause_r_0}</strong>
                )}
              </li>
              <li>
                {strings.formatString(
                  strings.termOfUsePage.text.pWithoutCause_s,
                  <strong>{strings.termOfUsePage.text.pWithoutCause_s_0}</strong>
                )}
              </li>
            </ul>
          </>
        </TriggerOnEnter>
        <TriggerOnEnter {...offset} onEnter={() => wayPointCallback('contact')}>
          <>
            <Title className="content__title content__title--3" tagName="h3" id="contact">
              {strings.termOfUsePage.text.pContactsTitle}
            </Title>
            <p>{strings.termOfUsePage.text.pHaveAnyQuestions}</p>
            <p>
              <a href="mailto: hello@staq.io">{strings.termOfUsePage.text.pMail}</a>
            </p>
            <p>{strings.termOfUsePage.text.pTermsUpdatedOn}</p>
          </>
        </TriggerOnEnter>
      </div>
    </div>
  );
};

Content.propTypes = {
  wayPointCallback: func,
  offset: object,
};

Content.defaultProps = {
  wayPointCallback: () => {},
  offset: {
    topOffset: '0',
    bottomOffset: '0',
  },
};
